import { render, staticRenderFns } from "./InvoiceModal.vue?vue&type=template&id=4e45f62c"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceModal.vue?vue&type=style&index=0&id=4e45f62c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./InvoiceModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports